import { render } from "./Plus.vue?vue&type=template&id=2d457816"
import script from "./Plus.vue?vue&type=script&lang=js"
export * from "./Plus.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Plus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d457816"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d457816', __exports__)) {
    api.reload('2d457816', __exports__)
  }
  
  module.hot.accept("./Plus.vue?vue&type=template&id=2d457816", () => {
    api.rerender('2d457816', render)
  })

}


export default __exports__